module.exports = __webpack_public_path__ + "img/animais.8be98801.svg";